import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';

import { Subject,combineLatest, map, startWith, timestamp } from 'rxjs';

import { SvinnReportService } from '../../services/svinn-report.service';
import { ConfigService } from 'src/app/shared/config';
@Component({
  selector: 'app-planner',
  templateUrl: './planner.component.html',
  styleUrls: ['./planner.component.css']
})
export class PlannerComponent implements OnInit {


  step = 0;
  systems$;
  systemsFilter$ = new Subject()
  filteredSystems$;
  items = []
  constructor(private config  : ConfigService, private svinnService : SvinnReportService){
    this.systems$ = this.svinnService.getMappingByCompanyId(this.config.getCompanyId())


    this.filteredSystems$ = combineLatest(
      this.systems$, this.systemsFilter$.pipe(startWith(""))).pipe(map(([data, filter]) => {
        return (data as Array<{}>).filter(option => option['systemName'] ? option['systemName'].toLowerCase().includes(filter) : "Test")
      }))

      this.filteredSystems$.subscribe(doc=>{
        console.log(doc)
        this.items.push(doc)
  })
  }
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  
  }


  ngOnInit() {
  }


  ngOnDestroy() {

  }
}

